<template>
  <div v-if="isLoggedIn" class="body_container">
    <lock-screen v-if="is_screen_lock" @unlock="handleUnlock" />

    <div v-if="!is_screen_lock" class="header_wrapper">
      <headers />
    </div>
    <div v-if="!is_screen_lock" class="parent_container" :class="{ mobile: $device?.mobile }">
      <!-- <side-nav /> -->
      <div class="content_container px-3 pb-2 pt-0">
        <router-view />
      </div>
    </div>
  </div>
  <!-- <div v-if="$device?.mobile && isLoggedIn" class="footer_wrapper">
    <footers />
  </div> -->
  <div v-if="!user?.name && isLoginPage">
    <router-view />
  </div>
</template>

<script>
import Headers from "@/components/navigation/header";
import Footers from "@/components/navigation/footer";
import LockScreen from "@/components/ui/lockscreen.vue";
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "App",
  components: { Headers, Footers, LockScreen },
  data() {
    return {
      inactive_timer: null,
      inactive_duration: 300000 // 5 minutes in milliseconds
    };
  },
  mounted() {
    this.resetScreenTimer();
    this.setupEventListeners();
    /*  this.setupVisibilityChangeListener(); */
  },
  beforeUnmount() {
    this.removeEventListeners();
    /*  this.removeVisibilityChangeListener(); */
  },
  created() {
    if (!this.user && !localStorage.getItem("token")) {
      this.$router.push({ path: "/login" });
    }
  },
  async beforeMount() {
    if (this.isLoggedIn) {
      const _user = await this.$store.dispatch("auth/fetchCurrentUser");
      if (_user) {
        this.$store.dispatch("users/refreshUserSettings", { _id: _user._id });
        this.$store.dispatch("notifications/fetchNewNotification", { _id: _user._id });
        document.querySelector("body").classList.add(`${_user?.settings?.theme}-theme`);
      }
    }
  },
  methods: {
    ...mapMutations({
      setScreenLock: "layout/setScreenLock"
    }),
    setupEventListeners() {
      window.addEventListener("mousemove", this.resetScreenTimer);
      window.addEventListener("keydown", this.resetScreenTimer);
      window.addEventListener("touchstart", this.resetScreenTimer);
    },
    removeEventListeners() {
      window.removeEventListener("mousemove", this.resetScreenTimer);
      window.removeEventListener("keydown", this.resetScreenTimer);
      window.removeEventListener("touchstart", this.resetScreenTimer);
    },
    setupVisibilityChangeListener() {
      document.addEventListener("visibilitychange", this.handleVisibilityChange);
    },
    removeVisibilityChangeListener() {
      document.removeEventListener("visibilitychange", this.handleVisibilityChange);
    },
    handleVisibilityChange() {
      if (document.visibilityState === "visible") this.resetScreenTimer();
      else this.setupLock();
    },
    resetScreenTimer() {
      clearTimeout(this.inactive_timer);
      this.inactive_timer = setTimeout(this.setupLock, this.inactive_duration);
    },
    setupLock() {
      this.setScreenLock(true);
    },
    handleUnlock() {
      this.setScreenLock(false);
      this.resetScreenTimer();
    }
  },
  computed: {
    ...mapGetters({
      is_screen_lock: "layout/is_screen_lock"
    }),
    isLoginPage() {
      return this.$route.path == "/login";
    },
    isLoggedIn() {
      const token = localStorage.getItem("token");
      return this?.user?.name || (token && token !== "");
    }
  }
};
</script>


<style lang="scss" scoped>
.footer_wrapper {
  background-color: var(--header-background-color);
  box-shadow: inset 0 -2px 0 0 var(--header-shadow-color);
  font-weight: 600;
  color: #c6c7c8;
  /* box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 50%); */
  /* border-bottom: 2px solid rgba(87, 89, 102, 0.6); */
  height: var(--footer_height);
  min-height: var(--footer_height);
  position: sticky;
  bottom: 0;
  width: 100%;
  z-index: 1;
}
</style>